import { AfterContentInit, ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { AbreCuentasService } from 'src/app/shared/services/abre-cuentas/abre-cuentas.service';
import { CopyService } from 'src/app/shared/services/copies/copy.service';
import { HeaderService } from 'src/app/shared/services/header/header.service';
import { NavigationService } from 'src/app/shared/services/navigation/navigation-onboarding.service';

@Component({
  selector: 'app-amount-request',
  templateUrl: './amount-request.component.html',
  styleUrls: ['./amount-request.component.scss'],
})
export class AmountRequestComponent implements OnInit, AfterContentInit {
  formGroup: FormGroup;
  amount: any;
  amountModel: any;
  activeInput = false;
  config = {
    allowNegative: false,
    decimal: ',',
    precision: 0,
    thousands: '.',
    prefix: '$ ',
  };

  constructor(
    public copyService: CopyService,
    private abreCuentasService: AbreCuentasService,
    private navigationService: NavigationService,
    private headerService: HeaderService,
    private formBuilder: FormBuilder,
    private cdr: ChangeDetectorRef,
  ) {
    this.headerService.show(false, true, true);
    this.formGroup = this.formBuilder.group({});
  }

  ngOnInit() {
    const amountValue = this.abreCuentasService.getAbreCuentasModel().creditParms.maxAmountValue;
    this.amount = amountValue ? amountValue : 0;
    this.formGroup = new FormGroup({
      amountValue: new FormControl(this.amount, [Validators.required, Validators.min(5000000), Validators.max(60000000)]),
    });
    this.formGroup.controls.amountValue.setValue(this.amount);
  }

  ngAfterContentInit(): void {
    this.headerService.show(false, true, true);

    this.cdr.detectChanges();
  }

  reactiveInputChangeAmount() {
    const controlAmount = this.formGroup.controls['amountValue'] as FormControl;
    const value = controlAmount.value.split('.');
    // this.amount = value[0];
    this.amountModel = value[0];
  }
  /**
   *  Summary Handless the onFocus event
   */
  reactiveOnFocus() {
    this.activeInput = true;
  }

  next() {
    this.abreCuentasService.getAbreCuentasModel().creditParms.maxAmountValue = this.amountModel;
    this.navigationService.nextStep('200');
  }

}
